import type {Poll, PollOption, Post} from "~/repository/types";
import type {Ref} from "vue";

export const usePollAPI = (post: Ref<Post>, poll: Ref<Poll>) => {
    const {$api} = useNuxtApp()

    async function vote(option: PollOption) {
        const optionIndex = poll.value.options.indexOf(option)
        await $api.posts.vote(post.value, poll.value, optionIndex)
        option.votes += 1;
        poll.value.total_votes += 1;
        poll.value.has_voted = true;
    }


    return {
        vote
    }
}